import { Link, LinkProps } from 'react-router-dom';

import ArrowLeftIcon from '../../../assets/arrow-left.svg?react';
import { ReactNode } from 'react';

export const BackLink = ({ to, children }: { to: LinkProps['to']; children: ReactNode }) => (
  <Link
    to={to}
    className="inline-flex items-center gap-2 text-lg text-neutral-700 hover:text-neutral-200 3xl:absolute 3xl:left-[78px]"
  >
    <ArrowLeftIcon />
    {children}
  </Link>
);
